import { render, staticRenderFns } from "./windowIfrram.vue?vue&type=template&id=43b09da4&scoped=true"
import script from "./windowIfrram.vue?vue&type=script&lang=js"
export * from "./windowIfrram.vue?vue&type=script&lang=js"
import style0 from "./windowIfrram.vue?vue&type=style&index=0&id=43b09da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b09da4",
  null
  
)

export default component.exports